// src/components/WarRoomLibrary.js
//
// Bob 2026-10-14: "should not the library or is it libraries be in the war room also". Yes - the committee works its
// claims and cases in the War Room, and the agreements are what it argues from. This opens THE Agreements library in
// place (src\pages\Agreements.js, the same page the menu opens - one library, never a second copy that could drift). It
// loads only when opened, so the room's own business stays first and the library costs nothing until it is wanted.
import React, { useState } from 'react';
import Agreements from '../pages/Agreements';

const C = { panel: '#0B1626', line: '#2E4A6B', dim: '#8AA4BF', accent: '#E8A020', text: '#DCE7F2' };

export default function WarRoomLibrary({ user }) {
  const [open, setOpen] = useState(false);
  return (
    <div style={{ border: '1px solid ' + C.line, background: C.panel, marginBottom: 14 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px 14px', gap: 12 }}>
        <div>
          <div style={{ fontSize: 13, fontWeight: 700, color: C.text }}>The library - the agreements</div>
          <div style={{ fontSize: 11, color: C.dim, marginTop: 2 }}>Every agreement your committee works under, its rules and the matrix entries confirmed by the General Chairperson - the same library as the Agreements page, opened here.</div>
        </div>
        <button type="button" className="btn btn-secondary btn-sm" onClick={() => setOpen(o => !o)}>{open ? 'Close the library' : 'Open the library'}</button>
      </div>
      {open ? <div style={{ borderTop: '1px solid ' + C.line, padding: '8px 4px' }}><Agreements user={user} /></div> : null}
    </div>
  );
}
